import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchPaystackConfigSuccess,
  fetchPaystackConfigFailure,
  fetchRemitaConfigSuccess,
  fetchRemitaConfigFailure,
  fetchInterswitchConfigSuccess,
  fetchNabrollConfigSuccess,
  fetchInterswitchConfigFailure,
  fetchNabrollConfigFailure
} from '../actions';
import paymentConfigTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* fetchPaystackConfig({ payload: id }) {
  const url = `${API_BASE_URL}/paylog-configurations/${id}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchPaystackConfigSuccess(response.raw));
  } else {
    yield put(
      fetchPaystackConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    if (response.statusCode === 404) {
      networkErrorHandler(response?.statusCode, 'Please use the correct paylog ID');
    } else {
      networkErrorHandler(response?.statusCode, 'An error occured. Please reload the page to try again.');
    }
  }
}
function* fetchNabrollConfig({ payload: id }) {
  const url = `${API_BASE_URL}/paylog-configurations/${id}`;
  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchNabrollConfigSuccess(response.raw));
  } else {
    yield put(
      fetchNabrollConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    if (response.statusCode === 404) {
      networkErrorHandler(response?.statusCode, 'Please use the correct paylog ID');
    } else {
      networkErrorHandler(response?.statusCode, 'An error occured. Please reload the page to try again.');
    }
  }
}
function* fetchRemitaConfig({ payload: id }) {
  const url = `${API_BASE_URL}/paylog-configurations/${id}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchRemitaConfigSuccess(response.raw));
  } else {
    yield put(
      fetchRemitaConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    if (response.statusCode === 404) {
      networkErrorHandler(response?.statusCode, 'Please use the correct paylog ID');
    } else {
      networkErrorHandler(response?.statusCode, 'An error occured. Please reload the page to try again.');
    }
  }
}

function* fetchInterswitchConfig({ payload: id }) {
  const url = `${API_BASE_URL}/paylog-configurations/${id}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchInterswitchConfigSuccess(response.raw));
  } else {
    yield put(
      fetchInterswitchConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    if (response.statusCode === 404) {
      networkErrorHandler(response?.statusCode, 'Please use the correct paylog ID');
    } else {
      networkErrorHandler(response?.statusCode, 'An error occured. Please reload the page to try again.');
    }
  }
}

export function* getPaystackConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYSTACK_CONFIG_REQUEST,
    fetchPaystackConfig
  );
}
export function* getNabrollConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_NABROLL_CONFIG_REQUEST,
    fetchNabrollConfig
  );
}

export function* getRemitaConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_REMITA_CONFIG_REQUEST,
    fetchRemitaConfig
  );
}

export function* getInterswitchConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_REQUEST,
    fetchInterswitchConfig
  );
}
